import axios from 'lib/axios'

export const loadOrgMailroomSettings = (orgId) => axios.get(`/super/api/organizations/${orgId}/mailroom_settings`)

export const updateOrgMailroomSettings = (orgId, params) =>
  axios.patch(`/super/api/organizations/${orgId}/mailroom_settings`, { mailroom_setting: params })
